import { render, staticRenderFns } from "./VerticalButtons.vue?vue&type=template&id=4ba668d7&scoped=true&"
var script = {}
import style0 from "./VerticalButtons.vue?vue&type=style&index=0&id=4ba668d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba668d7",
  null
  
)

export default component.exports